import styled from 'styled-components';
import { Paper, FormControl } from '@material-ui/core';
import { motion } from 'framer-motion';

export const Container = styled(motion.div)`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 400px;

  img {
    width: 90%;
    margin-bottom: 30px;
  }
`;

export const FormContainer = styled(Paper)`
  padding: 24px;
  width: 100%;
  margin: auto;

  .footer {
    display: flex;
    justify-content: space-between;
    align-items: center;

    a {
      font-size: 10px;
    }

    .entrar {
      background-color: #f26522;
      margin-right: 24px;

      :hover {
        background-color: #f77336;
      }
    }
  }
`;

export const InputControl = styled(FormControl)`
  && {
    margin-bottom: 24px;
  }
`;
